import { readConsentFromBrowser } from './document-cookie';
import { hasAnalyticsConsent } from './has-analytics-consent';
import { isInternalQaExcludedInBrowser } from '../analytics/internal-qa-exclusion';
import { isProductionHostname } from '../analytics/production-hostnames';
import { VITE_DEV } from '../env/vite-env';

/** True when running in the browser and jc_consent_v1 allows analytics (and this isn't our own QA traffic). */
export function isClientAnalyticsAllowed(): boolean {
  if (typeof window === 'undefined') return false;
  // Local dev has no separate GA4 property: block every analytics call site that gates on
  // this (GA4 adapter, legacy analytics.ts), on every port, regardless of consent state.
  if (VITE_DEV) return false;
  // Belt-and-suspenders beyond the DEV check above: also blocks a future PR-preview/staging
  // deploy of this same production build (no separate CDK stack exists for either today, so
  // such a deploy would otherwise ship the real GA4 ID with no other guard against it).
  if (!isProductionHostname(window.location.hostname)) return false;
  if (isInternalQaExcludedInBrowser()) return false;
  return hasAnalyticsConsent(readConsentFromBrowser());
}
